import { Component, OnInit } from '@angular/core';
import { Auth } from '../auth.service';

@Component({
  selector: 'cw-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css']
})
export class ForgotPasswordComponent implements OnInit {
  email: string;
  errorMessage: string;

  constructor(private auth: Auth) {
  }

  ngOnInit() {
  }

  send() {
    this.auth.createResetToken(this.email).subscribe(ok => {
      console.log(ok);
    }, (err) => {
      console.log(err);
      this.errorMessage = err;
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/auth/forgot-password/forgot-password.component.ts